module.exports = __webpack_public_path__ + "static/media/pdf-box.ab58a2ed.svg";